import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import { RootState, AppDispatch } from "../../../../../../redux/store";
import {
    setFidelity,
    setSelectedRowsFidelity,
} from "../../../../../../redux/slices/fidelitySlice";

import "../../index.css";

export default function UniqueRowSelection(e: any) {
    const { t } = useTranslation();
    const fidelity = useSelector((s: RootState) => s.fidelity.fidelity);
    const dispatch = useDispatch<AppDispatch>();
    const isChecked = e.selectedRow.Id === fidelity;
    const isDisabled =
        e.selectedRow.Id !== fidelity &&
        fidelity !== "" &&
        fidelity !== undefined;

    const handleChange = () => {
        if (isChecked) {
            dispatch(setFidelity(""));
        } else {
            dispatch(setFidelity(e.selectedRow.Id));
            dispatch(setSelectedRowsFidelity(e.selectedRow));
        }
    };

    const rowLabel = e.selectedRow[t("Display name")] ?? "";
    const ariaLabel = `${t("Select fidelity")} ${rowLabel}`.trim();

    return (
        <input
            data-testid={`fidelity-shops-associate-row-checkbox-${e.selectedRow.Id}`}
            type="checkbox"
            aria-label={ariaLabel}
            aria-disabled={isDisabled}
            onChange={handleChange}
            checked={isChecked}
            disabled={isDisabled}
            className="checkbox_fiscalYear__clz"
        />
    );
}
